<companyid-content-wrapper classNames="flex-col pt-80px pb-120px gap-y-40px w-full mob:px-5 tab:px-5">
    <companyid-title-and-subtitle
        i18n-subtitle="@@subtitle-frequenty-asked-questions"
        title="FAQs"
        subtitle="Frequently asked questions"
        class="text-center"
    />
    <div class="flex flex-col desk:m-auto desk:w-[770px]">
        <hr class="w-full border border-solid border-dark mb-25px" />
        @for (item of faqsContent; track item.title) {
            <div class="flex w-full gap-x-30px mb-25px">
                <div class="flex flex-col w-full gap-y-2.5 px-2.5">
                    <div
                        aria-hidden="true"
                        class="flex justify-between items-center gap-30px cursor-pointer"
                        (click)="toggle(item)"
                    >
                        <span class="text-h6-semi-bold">{{ item.title }}</span>
                        <companyid-chevron color="black" [position]="item.isShown ? 'top' : 'bottom'" />
                    </div>

                    <span
                        [ngClass]="[
                            'overflow-hidden transition-all duration-300 ease-in-out text-medium-regular',
                            item.isShown ? 'max-h-96' : 'max-h-0',
                        ]"
                    >
                        {{ item.subtitle }}
                    </span>
                </div>
            </div>
            <hr class="w-full border border-solid border-dark mb-25px" />
        }
    </div>
    <div class="flex justify-center items-center gap-15px mob:flex-col gap-y-15px">
        <span class="text-large-regular text-dark" i18n>Still have questions?</span>
        <a class="button-ghost-gray !px-7" routerLink="/contact-us">
            <span class="text-primary-color" i18n>Contact with us</span>
            <companyid-arrow color="blue" position="right" />
        </a>
    </div>
</companyid-content-wrapper>
